// Uberflip GWL OB-9893 start here
function changeDateTime() {
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const dateTime = document.querySelector('.single-page .meta-inner .date');
    if (dateTime) {
        const dateValue = dateTime.innerText;
        if (dateValue) {
            const mydate = new Date(dateValue);
            const dateFormat = month[mydate.getMonth()] + ' ' + mydate.getFullYear();
            dateTime.innerHTML = dateFormat;
        }
    }
}
export { changeDateTime };
// Uberflip GWL OB-9893 end here


// WEBPACK FOOTER //
// ./scriptPartials/itemLevel.js